import React from 'react';
import { Button } from '@roger/ui-components';
import { ChevronLeft, ChevronRight } from 'lucide-react';

type PaginationBarProps = {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  /** Noun for the count line, e.g. "visits" or "payrolls". */
  itemsLabel: string;
  onPageChange: (page: number) => void;
  disabled?: boolean;
};

/** Intake-Manager-style bottom pagination bar shared by the payroll screens. */
export const PaginationBar: React.FC<PaginationBarProps> = ({
  page,
  totalPages,
  total,
  pageSize,
  itemsLabel,
  onPageChange,
  disabled = false,
}) => (
  <div className='flex items-center justify-between border-t pt-4'>
    <div className='text-sm text-muted-foreground'>
      Showing {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, total)}{' '}
      of {total} {itemsLabel}
    </div>
    <div className='flex items-center gap-2'>
      <Button
        variant='outline'
        size='sm'
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1 || disabled}
      >
        <ChevronLeft className='h-4 w-4' />
        Previous
      </Button>
      <div className='text-sm px-2'>
        Page {page} of {totalPages}
      </div>
      <Button
        variant='outline'
        size='sm'
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages || disabled}
      >
        Next
        <ChevronRight className='h-4 w-4' />
      </Button>
    </div>
  </div>
);
